import CryptoJSCore from 'crypto-js/core';
import SHA1 from 'crypto-js/sha1';
import hasIn from 'lodash/hasIn';
import { select } from 'redux-saga/effects';

import * as D from './deps';

const log = D.Logger.child({ component: 'comscore/utils' });

/**
 * Gets SHA1 encrypted listenerId
 *
 * @returns {string} SHA1 encrypted listenerId
 */
export function* getCsXi() {
  if (yield select(D.Utils.Listener.isAnonymousListener)) {
    return log.info('getCsXi(): anonymous user detected');
  }

  const currentListenerId = yield select(D.Utils.Listener.getCurrentListenerIdFromState);
  return SHA1(currentListenerId).toString(CryptoJSCore.enc.Base64);
}

/**
 * Build and return string containing listener age and gender
 *
 * @returns {string} concatenated string of listener age and gender
 */
export function* getCsWn() {
  if (yield select(D.Utils.Listener.isAnonymousListener)) {
    return log.info('getCsWn(): anonymous user detected');
  }

  const genderCodeEnums = {
    MALE: 1,
    FEMALE: 2,
    '': 0,
  };

  const year = parseInt(yield select(D.Utils.Listener.getCurrentUserBirthYear), 10) + 1999;
  const gender = genderCodeEnums[yield select(D.Utils.Listener.getCurrentUserGender)];

  return `u${year}z${gender}`;
}

/**
 * Call Comscore beacon
 *
 * @param  {object} params - QueryString params to apply to beacon call
 * @returns {null}     [description]
 */
// eslint-disable-next-line require-yield
export function* pingComscore(params = {}) {
  if (!hasIn(window, 'COMSCORE.beacon')) {
    return log.info('pingComscore(): COMSCORE not loaded');
  }

  // default
  const extendedParams = Object.assign(
    {},
    {
      c1: 2,
      c2: '6036333',
      c3: '',
      c4: '',
      c5: '',
      c6: '',
      c15: '',
    },
    params,
  );

  log.info('pingComscore(): pinging');

  window.COMSCORE.beacon(extendedParams);
}
